import { BaseUrlService } from './base-url.service';

export class DropboxService {
    static $inject: string[] = ['$http', 'BaseUrlService', '$rootScope'];

    private baseUrl: any;

    constructor(
        private $http: ng.IHttpService,
        private _baseUrlService: BaseUrlService,
        private $rootScope: any
    ) {
        this.baseUrl = _baseUrlService.getBaseUrl();
    }

    uploadFiles(files: any) {
        return this.$http.post(this.baseUrl + '/dropbox/upload-files', files);
    }

    authorize(code: any) {
        return this.$http.put(this.baseUrl + '/dropbox/authorize/' + encodeURIComponent(this.$rootScope.domain), code);
    }

    getAuthorizationUrl() {
        return this.$http.get(this.baseUrl + '/dropbox/authorization-url/' + encodeURIComponent(this.$rootScope.domain));
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/dropbox.service.ts